import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseLocalRepository } from '@data/base/base-local.repository';
import { map, Observable } from 'rxjs';
import { ApiResources } from '@constants/api-resources';
import { ReservaEntity } from '@domain/dto/reserva/reserva-post.dto';
import { CupomEntity } from '@domain/dto/reserva/reserva-cupom-get.dto';
import { CupomMapper } from './reserva-cupom.mapper';


@Injectable()
export class ReservaRepository extends BaseLocalRepository {
  private mapper = new CupomMapper();
  constructor(httpClient: HttpClient) {
    super(httpClient, ApiResources.RESERVA);
  }
  insert(param: ReservaEntity): Observable<ReservaEntity> {
    this.basePath = ApiResources.RESERVA;
    return this.postRequest<ReservaEntity>(param);
  }

  getById(cupom: string): Observable<CupomEntity> {
    this.basePath = ApiResources.RESERVA_CUPOM;
    return this.getByIdRequest(cupom).pipe(
      map((item) => {
        if (Array.isArray(item) && item[0]) {
          return this.mapper.fromJson(item[0]);
        }
        return item;
      })
    );
  }

  getCustomById(field: string, value: string): Observable<any> {
    this.basePath = ApiResources.RESERVA_CUPOM;
    return this.getCustomByIdRequest(field, value).pipe(
      map((item) => {
        if (Array.isArray(item) && item[0]) {
          return this.mapper.fromJson(item[0]);
        }
        return item;
      })
    );
  }
}
